import * as types from "./actionTypes";

export const getFile = pageNumber => {
  return {
    type: types.GET_FILES_REQUEST,
    pageNumber
  };
};
export const getFileSuccess = data => {
  return {
    type: types.GET_FILES_SUCCESS,
    data
  };
};
export const getFileFailure = error => {
  return {
    type: types.GET_FILES_FAILURE,
    error
  };
};

export const removeFile = (id, pageNumber = null) => {
  return {
    type: types.REMOVE_FILE_REQUEST,
    id,
    pageNumber
  };
};
export const removeFileSuccess = id => {
  return {
    type: types.REMOVE_FILE_SUCCESS,
    id
  };
};
export const removeFileFailure = id => {
  return {
    type: types.REMOVE_FILE_FAILURE,
    id
  };
};
